import jQuery from 'jquery';

function animateNavHighlight(this: HTMLElement): void {
    const parent = this.parentElement;
    const highlight = jQuery('.navbar-item-highlight').get(0);

    if (!parent || !highlight) {
        return;
    }

    const parentRect = parent.getBoundingClientRect();
    const targetRect = this.getBoundingClientRect();

    const left = Math.abs(parentRect.left - targetRect.left);
    const width = targetRect.width;

    requestAnimationFrame(() => {
        highlight.style.left = `${left}px`;
        highlight.style.width = `${width}px`;
    });
}

function attachMenuItem(): void {
    const menuItems = jQuery('.navbar-menu .navbar-item');
    const activeMenuItems = menuItems.filter((_: number, item: HTMLElement) => item.classList.contains('is-active'));

    if (activeMenuItems.length > 0) {
        jQuery(window).on('resize', animateNavHighlight.bind(activeMenuItems[0])); // tslint:disable-line no-unsafe-any
    }

    menuItems.each((_: number, item: HTMLElement) => {
        jQuery(item)
            .on('mouseenter', animateNavHighlight)
            .on('mouseleave', resetNavHighlight);
    });
}

function resetNavHighlight(): void {
    jQuery('.navbar-menu .navbar-item.is-active').each(animateNavHighlight);
}

/**
 * Attach the navbar events.
 */
export function attach(): void {
    resetNavHighlight();
    attachMenuItem();
}
